import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";

const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

@Injectable({
  providedIn: "root"
})
export class TpSlaTrendService {
  apiUrl = environment.gateWayHost;
  editItem: any;

  constructor(public generic: GenericHttpService) {}

  getSLArendData(url, params): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.apiUrl}${url}`,
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processSLArends)
    );
  }
  processSLArends(data: any) {
    if (!data.data.length || (data.data.length && !Object.keys(data.data[0]).length)) return null;
    const percentage = [],
      volume = [];

    const labels = data.data[0].TransportationSlaTrend.map(value => {
      const aDate = new Date(value.order_date);
      const total =
        value.breached_quantity +
        value.non_breached_quantity;
      const toFixed = (value.non_breached_quantity / total) * 100;
      percentage.push(Number(toFixed.toFixed(2)));
      volume.push(total + value.in_process_quantity);
      return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
    });

    return { labels, percentage, volume };
  }

  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    chart.xAxis[0].categories = chartData.labels;
    chart.series[0].data = chartData.percentage;
    chart.series[0].name = Options.yaxisleft;
    chart.series[1].data = chartData.volume;
    chart.series[1].name = "Quantity";

    chart.yAxis[0].title.text = Options.yaxisleft;
    chart.yAxis[1].title.text = Options.yaxisright;

    return chart;
  }
}
